module.exports = __webpack_public_path__ + "static/media/duration1.941fdb7e.png";